import { OpenAPI } from 'api-clients/monolith/core/OpenAPI';
import { request as __request } from 'api-clients/monolith/core/request';

import { CreateReply } from './createReply';

import type { CancelablePromise } from 'api-clients/monolith/core/CancelablePromise';

// The generated client does not support sending `FormData` directly in the body
// Until this reusing the same client and manually setting types and passing FormData in the body
export const postInternalApiPortalApplicationForms = (
  accountSlug: string,
  funnelId: string,
  formData: FormData,
): CancelablePromise<CreateReply> => {
  return __request(OpenAPI, {
    method: 'POST',
    url: '/internal_api/portal/{account_slug}/application_forms',
    path: {
      account_slug: accountSlug,
    },
    query: {
      funnel_id: funnelId,
    },
    body: formData,
  });
};
